import { render, staticRenderFns } from "./SolicitacaoDeOrcamentoView.vue?vue&type=template&id=f22402cc&scoped=true"
import script from "./SolicitacaoDeOrcamentoView.vue?vue&type=script&lang=js"
export * from "./SolicitacaoDeOrcamentoView.vue?vue&type=script&lang=js"
import style0 from "./SolicitacaoDeOrcamentoView.vue?vue&type=style&index=0&id=f22402cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22402cc",
  null
  
)

export default component.exports